// EXTERNAL: All
// -------------------------------

import React  from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';


import defaults from './constants/defaults';
import pages from './navigation/pages';


// INTERNAL: Foundational
// -------------------------------

import Intercom from '@intercom/messenger-js-sdk';

import reportWebVitals from './reportWebVitals';
import { authenticate } from './services';
import { store } from './state/store';
import './constants/index.css';
import App from './App';




import { History } from './services';

import ReactGA4 from 'react-ga4';

// ReactGA4.initialize('XXX', { debug: true }); // TO MOVE TO ENV VARIABLE


// Establish browswer routing information
// -------------------------------


const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];

if (path) {
    History.history.replace(path);
}


// Intercom({
//   app_id: 'xxx'
// })



// PRIMARY RENDER
// -------------------------------

ReactDOM.render(
  <React.StrictMode>

    <Provider store={store}>
        <BrowserRouter>
        
            <App>
              {({ injectedProps }) => (
                <Switch>
                  
                    {
                      
                      // Populate pages from pages.js

                      pages.map(({ PageType, pagePath, pageComponent: PageCmp }) => {
                        return <PageType 
                            key={pagePath} 
                            path={pagePath} 
                            exact 
                            render={(routeProps) => (
                              <PageCmp {...routeProps} {...injectedProps} />
                            )} 
                          />
                      })

                    }

                    <authenticate.NoPath />

                </Switch>
                )}
            </App>
        </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);


// --------------------------------------------------------
// --
// -- CONTEXT TOOLING
// --
// --------------------------------------------------------

if (process.env.NODE_ENV === 'development') {
  console.log(defaults.console.START_MESSAGE_DEV);
} else {
  console.log(defaults.console.START_MESSAGE_PROD);
  // reportWebVitals(console.log);
}